module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_5.5ea65b28.png";